// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608200034/js/" + chunkId + "." + {"44":"9f2e70c7","225":"72501f44","481":"05f56b9d","486":"4d5bcee2","770":"bb442868"}[chunkId] + ".0.14905326463402813.chunk.js";
};